import { computed } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { Spanish } from "flatpickr/dist/l10n/es.js"

export const types = computed(() => {
  return [
    { value: 'bool', title: i18n.t('behaviourTypes.bool') },
    { value: 'rating', title: i18n.t('behaviourTypes.rating') },
    { value: 'text', title: i18n.t('behaviourTypes.text') },
    { value: 'statement', title: i18n.t('behaviourTypes.statement') },
  ]
})

export const yesNoOptions = computed(() => {
  return [
    { value: true, title: i18n.t('message.yes') },
    { value: false, title: i18n.t('message.no') }
  ]
})

export const stateOptions = computed(() => {
  return [
    { value: true, title: i18n.t('completed') },
    { value: false, title: i18n.t('incomplete') }
  ]
})

export const actionPlanOptions = computed (() =>{
  return [
    { value: 'immediate', title: i18n.t('immediate') },
    { value: 'in_term', title: i18n.t('in_term') }
  ]
})

export const resultOptions = computed (() =>{
  return [
    { value: 'approved', title: i18n.t('approved') },
    { value: 'rejected', title: i18n.t('rejected') }
  ]
})

export const correctiveResultOptions = computed (() =>{
  return [
    { value: 'approved', title: i18n.t('executed') },
    { value: 'rejected', title: i18n.t('notExecuted') }
  ]
})

export const inTermApprovalStageOptions = computed (() =>{
  return [
    { value: 'analysis', title: i18n.t('analysisStage') },
    { value: 'corrective', title: i18n.t('correctiveStage') }
  ]
})

export const inTermApprovalStageComplaintOptions = computed (() =>{
  return [
    { value: 'analysis', title: i18n.t('analysisStage') },
    { value: 'corrective', title: i18n.t('investigationStage') }
  ]
})

export const correctiveStageOptions = computed (() =>{
  return [
    { value: 'analysis', title: i18n.t('analysisStage') },
    { value: 'verification', title: i18n.t('verificationStage') }
  ]
})

export const immediateVerificationStageOptions = computed (() =>{
  return [
    { value: 'analysis', title: i18n.t('analysisStage') },
    { value: 'end', title: i18n.t('endStage') },
  ]
})

export const inTermVerificationStageOptions = computed (() =>{
  return [
    { value: 'analysis', title: i18n.t('analysisStage') },
    { value: 'corrective', title: i18n.t('correctiveStage') },
    { value: 'end', title: i18n.t('endStage') }
  ]
})

export const inTermVerificationStageComplaintOptions = computed (() =>{
  return [
    { value: 'analysis', title: i18n.t('analysisStage') },
    { value: 'corrective', title: i18n.t('investigationStage') },
    { value: 'end', title: i18n.t('endStage') }
  ]
})

export const implementationStageOptions = computed (() =>{
  return [
    { value: 'correctiveMeasures', title: i18n.t('correctiveMeasuresStage') },
    { value: 'finalized', title: i18n.t('finalizedStage') }
  ]
})

export const immediateFinalizedStageOptions = computed (() =>{
  return [
    { value: 'correctiveMeasures', title: i18n.t('correctiveMeasuresStage') },
    { value: 'end', title: i18n.t('endStage') }
  ]
})

export const inTermFinalizedStageOptions = computed (() =>{
  return [
    { value: 'correctiveMeasures', title: i18n.t('correctiveMeasuresStage') },
    { value: 'implementation', title: i18n.t('implementationStage') },
    { value: 'end', title: i18n.t('endStage') }
  ]
})

export const complianceCalculationFixedNumber = 10

export const complaintThemes = computed (() =>{
  return [
    { value: 'adulteration_of_financial_statements', title: i18n.t('complaintThemes.adulteration_of_financial_statements') },
    { value: 'misappropriation', title: i18n.t('complaintThemes.misappropriation') },
    { value: 'accounting_and_audit_matters', title: i18n.t('complaintThemes.accounting_and_audit_matters') },
    { value: 'incorrect_conduct_or_inappropriate_behavior', title: i18n.t('complaintThemes.incorrect_conduct_or_inappropriate_behavior') },
    { value: 'interest_conflict', title: i18n.t('complaintThemes.interest_conflict') },
    { value: 'corruption_among_private_individuals', title: i18n.t('complaintThemes.corruption_among_private_individuals') },
    { value: 'corruption_crime', title: i18n.t('complaintThemes.corruption_crime') },
    { value: 'bribery_crime', title: i18n.t('complaintThemes.bribery_crime') },
    { value: 'discrimination', title: i18n.t('complaintThemes.discrimination') },
    { value: 'workplace_discrimination', title: i18n.t('complaintThemes.workplace_discrimination') },
    { value: 'terrorist_financing', title: i18n.t('complaintThemes.terrorist_financing') },
    { value: 'fraud', title: i18n.t('complaintThemes.fraud') },
    { value: 'policy_violations', title: i18n.t('complaintThemes.policy_violations') },
    { value: 'money_laundering', title: i18n.t('complaintThemes.money_laundering') },
    { value: 'injuries', title: i18n.t('complaintThemes.injuries') },
    { value: 'environmental_protection_law', title: i18n.t('complaintThemes.environmental_protection_law') },
    { value: 'misuse_of_resources', title: i18n.t('complaintThemes.misuse_of_resources') },
    { value: 'environment', title: i18n.t('complaintThemes.environment') },
    { value: 'receiving', title: i18n.t('complaintThemes.receiving') },
    { value: 'robbery_or_theft', title: i18n.t('complaintThemes.robbery_or_theft') },
    { value: 'occupational_health_and_safety', title: i18n.t('complaintThemes.occupational_health_and_safety') },
    { value: 'ti', title: i18n.t('complaintThemes.ti') },
    { value: 'use_of_privileged_or_confidential_information', title: i18n.t('complaintThemes.use_of_privileged_or_confidential_information') },
  ]
})

export const karinLawThemes = computed (() =>{
  return [
    { value: 'workplace_harassment', title: i18n.t('complaintThemes.workplace_harassment') },
    { value: 'sexual_harassment', title: i18n.t('complaintThemes.sexual_harassment') },
    { value: 'violence_at_work', title: i18n.t('complaintThemes.violence_at_work') },
  ]
})

export const complaintRelationshipOptions = computed (() =>{
  return [
    { value: 'collaborator', title: i18n.t('companyRelationships.collaborator') },
    { value: 'supplier', title: i18n.t('companyRelationships.supplier') },
    { value: 'customer', title: i18n.t('companyRelationships.customer') },
  ]
})

export const complaintTypesOptions = computed (() =>{
  return [
    { value: 'economicCrimesLaw', title: i18n.t('label.economicCrimesLaw') },
    { value: 'karinLaw', title: i18n.t('label.karinLaw') },
    { value: 'ethicalSituations', title: i18n.t('label.ethicalSituations') },
  ]
})

export const flatPickrConfig = {
  dateFormat: 'd-m-Y',
  locale: Spanish,
  onDayCreate: (dObj, dStr, fp, dayElem) => {
    const date = dayElem.dateObj
    const day = date.getDay()
    if (day === 0 || day === 6) {
      dayElem.classList.add('weekend')
    }
  }
}

export const userTypeOptions = computed (() =>{
  return [
    { value: 'author', title: i18n.t('complaintUserTypes.author') },
    { value: 'affected', title: i18n.t('complaintUserTypes.affected') },
    { value: 'reported', title: i18n.t('complaintUserTypes.reported') }
  ]
})

// Input file types (PDF, Word, Images, Excel, CSV, Audio, Video)
export const inputFileTypes = ".pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/*,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xls,.xlsx,text/csv,.csv,.msg,application/vnd.ms-outlook,.eml,message/rfc822,.mbox,application/mbox,audio/*,.mp3,.wav,.m4a,.aac,.ogg,.oga,.opus,.amr,.flac,.wma,video/*,.mp4,.mov,.avi,.webm,.mkv,.wmv,.3gp,.m4v"

export const residualRiskOptions = computed (() =>{
  return [
    { value: 'veryLow', title: i18n.t('residualRisk.veryLow') },
    { value: 'low', title: i18n.t('residualRisk.low') },
    { value: 'medium', title: i18n.t('residualRisk.medium') },
    { value: 'high', title: i18n.t('residualRisk.high') },
    { value: 'veryHigh', title: i18n.t('residualRisk.veryHigh') }
  ]
})

export const residualRiskColors = {
  veryLow: '#006400',     // verde oscuro
  low: '#2e8b57',         // verde claro
  medium: '#d4a017',      // amarillo
  high: '#ff8c00',        // naranja
  veryHigh: '#cc0000'     // rojo
}

export const processTypes = computed (() =>{
  return [
    { value: 'R', title: i18n.t('processTypes.risk') },
    { value: 'F', title: i18n.t('processTypes.form') },
    { value: 'P', title: i18n.t('processTypes.process') }
  ]
})

export const ratingLabels = computed (() =>{
  return [
    i18n.t('ratingLabels.notStarted'),
    i18n.t('ratingLabels.planned'),
    i18n.t('ratingLabels.executed'),
    i18n.t('ratingLabels.verified'),
    i18n.t('ratingLabels.givenFeedback'),
  ]
})

export const actionPlanNames = computed (() =>{
  return [
    { value: 'complaintCommunicationExistence', title: i18n.t('actionPlanNames.complaintCommunicationExistence') },
    { value: 'safeguardMeasures', title: i18n.t('actionPlanNames.safeguardMeasures') },
    { value: 'investigationDiligenceDocumentaryRecord', title: i18n.t('actionPlanNames.investigationDiligenceDocumentaryRecord') },
    { value: 'investigationDiligenceAudiovisualRecord', title: i18n.t('actionPlanNames.investigationDiligenceAudiovisualRecord') },
    { value: 'investigationDiligenceTestimonyRecord', title: i18n.t('actionPlanNames.investigationDiligenceTestimonyRecord') },
    { value: 'investigationConclusionReport', title: i18n.t('actionPlanNames.investigationConclusionReport') },
  ]
})

export const actionPlanNamesCorrectiveMeasures = computed (() =>{
  return [
    { value: 'organizationalRestructuringModification', title: i18n.t('actionPlanNames.organizationalRestructuringModification') },
    { value: 'policyProtocolImprovement', title: i18n.t('actionPlanNames.policyProtocolImprovement') },
    { value: 'workdayModification', title: i18n.t('actionPlanNames.workdayModification') },
    { value: 'reinforcementTrainingTalk', title: i18n.t('actionPlanNames.reinforcementTrainingTalk') },
    { value: 'verbalWrittenWarning', title: i18n.t('actionPlanNames.verbalWrittenWarning') },
    { value: 'fine', title: i18n.t('actionPlanNames.fine') },
  ]
})

export const probabilityOptions = computed (() =>{
  return [
    { value: 'unlikely', title: i18n.t('residualRiskWithNumbers.unlikely') },
    { value: 'lowProbability', title: i18n.t('residualRiskWithNumbers.lowProbability') },
    { value: 'possible', title: i18n.t('residualRiskWithNumbers.possible') },
    { value: 'likely', title: i18n.t('residualRiskWithNumbers.likely') },
    { value: 'almostCertainly', title: i18n.t('residualRiskWithNumbers.almostCertainly') }
  ]
})

export const impactOptions = computed (() =>{
  return [
    { value: 'veryLow', title: i18n.t('residualRiskWithNumbers.veryLow') },
    { value: 'low', title: i18n.t('residualRiskWithNumbers.low') },
    { value: 'medium', title: i18n.t('residualRiskWithNumbers.medium') },
    { value: 'high', title: i18n.t('residualRiskWithNumbers.high') },
    { value: 'veryHigh', title: i18n.t('residualRiskWithNumbers.veryHigh') }
  ]
})

export const riskLevelOptions = computed (() => {
  return [
    { label: i18n.t('residualRisk.veryLow'), value: 'veryLow' },
    { label: i18n.t('residualRisk.low'), value: 'low' },
    { label: i18n.t('residualRisk.medium'), value: 'medium' },
    { label: i18n.t('residualRisk.high'), value: 'high' },
    { label: i18n.t('residualRisk.veryHigh'), value: 'veryHigh' },
  ]
})

export const probabilityValues = {
  unlikely: 1,
  lowProbability: 2,
  possible: 3,
  likely: 4,
  almostCertainly: 5,
}

export const impactValues = {
  veryLow: 1,
  low: 2,
  medium: 3,
  high: 4,
  veryHigh: 5,
}

// Standard heat map for regular clients
export const standardHeatMapRiskMatrix = {
  // Matrix: [impact][probability] = risk category
  // Impact: 1=veryLow, 2=low, 3=medium, 4=high, 5=veryHigh
  // Probability: 1=unlikely, 2=lowProbability, 3=possible, 4=likely, 5=almostCertainly
  1: { 1: 'low', 2: 'low', 3: 'low', 4: 'low', 5: 'medium' },
  2: { 1: 'low', 2: 'low', 3: 'medium', 4: 'medium', 5: 'high' },
  3: { 1: 'low', 2: 'medium', 3: 'medium', 4: 'high', 5: 'veryHigh' },
  4: { 1: 'low', 2: 'medium', 3: 'high', 4: 'veryHigh', 5: 'veryHigh' },
  5: { 1: 'medium', 2: 'high', 3: 'veryHigh', 4: 'veryHigh', 5: 'veryHigh' },
}

// Custom heat map for LV client (based on decimal risk values)
export const customHeatMapRiskMatrix = {
  1: { 1: 'low', 2: 'low', 3: 'medium', 4: 'high', 5: 'high' },
  2: { 1: 'low', 2: 'low', 3: 'high', 4: 'veryHigh', 5: 'veryHigh' },
  3: { 1: 'medium', 2: 'high', 3: 'veryHigh', 4: 'veryHigh', 5: 'veryHigh' },
  4: { 1: 'high', 2: 'veryHigh', 3: 'veryHigh', 4: 'veryHigh', 5: 'veryHigh' },
  5: { 1: 'high', 2: 'veryHigh', 3: 'veryHigh', 4: 'veryHigh', 5: 'veryHigh' },
}

export const chartColors = {
  primaryColorShade: '#836AF9',
  yellowColor: '#ffe800',
  successColorShade: '#28dac6',
  warningColorShade: '#ffe802',
  warningLightColor: '#FDAC34',
  infoColorShade: '#299AFF',
  greyColor: '#4F5D70',
  blueColor: '#2c9aff',
  blueLightColor: '#84D0FF',
  greyLightColor: '#EDF1F4',
  tooltipShadow: 'rgba(0, 0, 0, 0.25)',
  lineChartPrimary: '#666ee8',
  lineChartDanger: '#ff4961',
  labelColor: '#6e6b7b',
  grid_line_color: 'rgba(200, 200, 200, 0.2)',
}

export const conflicOfInterestTopicOptions = computed (() =>{
  return [
    { value: 'conflictOfInterest', title: i18n.t('label.conflictOfInterest') },
    { value: 'ciUpdate', title: i18n.t('label.ciUpdate') },
  ]
})

// Privacy filter options
export const rolPrivacyOptions = computed (() =>{
  return [
    { value: 'responsible', title: i18n.t('label.responsible') },
    { value: 'inCharge', title: i18n.t('label.inCharge') },
    { value: 'coResponsible', title: i18n.t('label.coResponsible') },
  ]
})

export const ambitoOptions = computed (() =>{
  return [
    { value: 'national', title: i18n.t('label.national') },
    { value: 'international', title: i18n.t('label.international') },
  ]
})

export const volumenOptions = ['< 100', '100 - 1.000', '1.000 - 10.000', '10.000 - 100.000', '> 100.000']
export const legitimacionOptions = ['Consentimiento', 'Contrato', 'Obligación legal', 'Interés vital', 'Interés público', 'Interés legítimo']
export const tipoDatoOptions = [
  'Identificación',
  'Contacto',
  'Características personales',
  'Académicos y profesionales',
  'Detalles de empleo',
  'Económicos, financieros y seguros',
  'Transaccionales',
]
export const excepcionSensibleOptions = ['Consentimiento explícito', 'Obligación legal', 'Interés vital', 'Datos públicos', 'Reclamación judicial']
export const periodicidadOptions = ['Única', 'Periódica', 'Continua']
export const origenOptions = ['Del titular', 'De terceros', 'De fuentes públicas']
export const soporteOptions = ['Papel', 'Digital', 'Mixto']
export const formatoOptions = ['Texto', 'Audio', 'Video', 'Imagen', 'Mixto']
export const conservacionOptions = ['< 1 año', '1 - 3 años', '3 - 5 años', '5 - 10 años', '> 10 años', 'Indefinido']

export const defaultPassword = '12345678'